import { render, staticRenderFns } from "./DialogProjectAssignment.vue?vue&type=template&id=f752cee4&"
import script from "./DialogProjectAssignment.vue?vue&type=script&lang=js&"
export * from "./DialogProjectAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports